import React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  List,
  ListItem,
  ListItemText,
  Theme,
  Divider,
  ListItemAvatar,
  ListItemSecondaryAction,
} from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ResponseTypeComponent from "../components/ResponseTypeComponent";
import { RESPONSE_TYPES } from "../constants/constants";
const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  selectedOption: any;
  open: any;
  handleClose: any;
  handleOnSubmit: any;
}
class SelectResponseTypeDialog extends React.Component<Props> {
  state = {
    searchText: "",
  };
  render() {
    const {
      title,
      selectedOption,
      open,
      handleClose,
      handleOnSubmit,
      classes,
    } = this.props;
    let responseTypes = RESPONSE_TYPES.filter((obj: any) => {
      return obj.title
        .toUpperCase()
        .includes(this.state.searchText.toUpperCase());
    });
    responseTypes = responseTypes.length > 0 ? responseTypes : RESPONSE_TYPES;
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Search for response type..."
              fullWidth
              onChange={(event) => {
                this.setState({
                  searchText: event.target.value,
                });
              }}
            />
            <List className={classes.root}>
              {responseTypes.map((option: any, index: any) => {
                return (
                  <div key={`${index}-index`}>
                    <ListItem button onClick={() => handleOnSubmit(option)}>
                      <ListItemAvatar>
                        <ResponseTypeComponent
                          feedBack={false}
                          typeKey={option.title}
                        />
                      </ListItemAvatar>
                      <ListItemText primary={option.label} />
                      {selectedOption.title === option.title && (
                        <ListItemSecondaryAction>
                          <CheckCircleOutlineIcon />
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                    <Divider component="li" />
                  </div>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(SelectResponseTypeDialog);
